
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="基础功能" fileName="base.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-table
            :max-height=&quot;350&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            borderY
            :rowStyleOption=&quot;rowStyleOption&quot;
            :cell-autofill-option=&quot;cellAutofillOption&quot;
            :edit-option=&quot;editOption&quot;
            row-key-field-name=&quot;rowKey&quot;
            :clipboard-option=&quot;clipboardOption&quot;
            :virtual-scroll-option=&quot;virtualScrollOption&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // clipboard option
                clipboardOption: {
                    copy: true,
                    paste: true,
                    cut: true,
                    delete: true,
                    beforeCopy: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;beforeCopy&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterCopy: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;afterCopy&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    beforePaste: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;beforePaste&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterPaste: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;afterPaste&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    beforeCut: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;beforeCut&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterCut: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;afterCut&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    beforeDelete: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;beforeDelete&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterDelete: ({ data, selectionRangeIndexes, selectionRangeKeys }) =&gt; {
                        console.log(&quot;afterDelete&quot;);
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                },
                virtualScrollOption: {
                    // 是否开启
                    enable: false,
                },
                cellAutofillOption: true,
                editOption: {
                    // cell value change
                    cellValueChange: ({ row, column }) =&gt; {},
                },
                columns: [
                    {
                        field: &quot;index&quot;,
                        key: &quot;index&quot;,
                        operationColumn: true,
                        title: &quot;#&quot;,
                        width: 35,
                        align: &quot;center&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    { field: &quot;col1&quot;, key: &quot;col1&quot;, title: &quot;Col1&quot;, edit: true, width: 150 },
                    { field: &quot;col2&quot;, key: &quot;col2&quot;, title: &quot;Col2&quot;, edit: true, width: 150 },
                    { field: &quot;col3&quot;, key: &quot;col3&quot;, title: &quot;Col3&quot;, edit: true, width: 150 },
                    { field: &quot;col4&quot;, key: &quot;col4&quot;, title: &quot;Col4&quot;, edit: true, width: 150 },
                    { field: &quot;col5&quot;, key: &quot;col5&quot;, title: &quot;Col5&quot;, edit: true, width: 150 },
                    { field: &quot;col6&quot;, key: &quot;col6&quot;, title: &quot;Col6&quot;, edit: true, width: 150 },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 100; i++) {
                    data.push({
                        rowKey: `row${i}`,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
            log({ data, selectionRangeIndexes, selectionRangeKeys }) {
                console.log(&quot;data::&quot;, data);
                console.log(&quot;selectionRangeIndexes::&quot;, selectionRangeIndexes);
                console.log(&quot;selectionRangeKeys::&quot;, selectionRangeKeys);
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-table',{attrs:{"max-height":350,"columns":_vm.columns,"table-data":_vm.tableData,"borderY":"","rowStyleOption":_vm.rowStyleOption,"cell-autofill-option":_vm.cellAutofillOption,"edit-option":_vm.editOption,"row-key-field-name":"rowKey","clipboard-option":_vm.clipboardOption,"virtual-scroll-option":_vm.virtualScrollOption}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // clipboard option
                clipboardOption: {
                    copy: true,
                    paste: true,
                    cut: true,
                    delete: true,
                    beforeCopy: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("beforeCopy");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterCopy: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("afterCopy");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    beforePaste: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("beforePaste");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterPaste: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("afterPaste");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    beforeCut: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("beforeCut");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterCut: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("afterCut");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    beforeDelete: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("beforeDelete");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                    afterDelete: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                        console.log("afterDelete");
                        this.log({ data, selectionRangeIndexes, selectionRangeKeys });
                    },
                },
                virtualScrollOption: {
                    // 是否开启
                    enable: false,
                },
                cellAutofillOption: true,
                editOption: {
                    // cell value change
                    cellValueChange: ({ row, column }) => {},
                },
                columns: [
                    {
                        field: "index",
                        key: "index",
                        operationColumn: true,
                        title: "#",
                        width: 35,
                        align: "center",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    { field: "col1", key: "col1", title: "Col1", edit: true, width: 150 },
                    { field: "col2", key: "col2", title: "Col2", edit: true, width: 150 },
                    { field: "col3", key: "col3", title: "Col3", edit: true, width: 150 },
                    { field: "col4", key: "col4", title: "Col4", edit: true, width: 150 },
                    { field: "col5", key: "col5", title: "Col5", edit: true, width: 150 },
                    { field: "col6", key: "col6", title: "Col6", edit: true, width: 150 },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 100; i++) {
                    data.push({
                        rowKey: `row${i}`,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
            log({ data, selectionRangeIndexes, selectionRangeKeys }) {
                console.log("data::", data);
                console.log("selectionRangeIndexes::", selectionRangeIndexes);
                console.log("selectionRangeKeys::", selectionRangeKeys);
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  